import cn from "classnames"
import React, { useState } from "react"
import { Label } from "reactstrap"
import "./InputLabel.scss"

interface IInputLabelProps {
    title?: string
    className?: string
    validationError?: string
    hint?: string
    children: React.ReactNode
}

export const InputLabel = ({ title, children, className, validationError, hint }: IInputLabelProps) => {
    const [showHint, setShowHint] = useState(false)

    return (
        <div className={cn("input-label", className)}>
            <Label className="input-label__label">
                {title}
                {children}
                {hint && (
                    <div className="input-label__hint-container">
                        <span
                            className="icon hint-icon"
                            onClick={(e) => {
                                e.preventDefault()
                                setShowHint(!showHint)
                            }}
                            onMouseOut={() => {
                                setShowHint(false)
                            }}
                            onTouchStart={() => {
                                setShowHint(true)
                            }}
                            onTouchEnd={() => {
                                setShowHint(false)
                            }}
                        ></span>
                        <span className={cn("hint-text", { "d-none": !showHint })}>{hint}</span>
                    </div>
                )}
            </Label>
        </div>
    )
}
